import React, { useContext, useState, useRef, useEffect } from 'react';
import { BannerContext } from '../../contexts/BannerDimensionsContext';
import './index.css';
import Preview from '../../components/preview';
import { useParams } from "react-router-dom";
import { getPreview } from '../../services/auth.js';

function DashboardPreview() {

  const { item } = useParams();

  const {
    listaReplicas, setListaReplicas,
    fullScreenLeft, setFullScreenLeft,
    fullScreenRight, setFullScreenRight,
    previewGridActive, setPreviewGridActive,
    previewGridHorizontal, setPreviewGridHorizontal,
    setLoading,
    setError
  } = useContext(BannerContext);

  var disabled = true;
  listaReplicas.forEach(element => {
    if (element.pack) {
      disabled = false;
    }
  });

  /**
   * 
   * @returns string
   */
  const [divWidthL, setDivWidthL] = useState('340px');
  const [divWidthR, setDivWidthR] = useState('340px');
  const [divWidthM, setDivWidthM] = useState('100vw');
  const [divWidthMM, setDivWidthMM] = useState('100vw');
  const [divPaddingMM, setDivPaddingMM] = useState('0');




  const handleGetPreview = async () => {

    setLoading({show: true, progress: false});

    const preview = await getPreview(item);

    setPreviewGridActive(true);
    setListaReplicas(preview);

    setLoading({show: false, progress: false});

  };


  useEffect(() => {

    handleGetPreview();

    function handleResize() {
      if (!fullScreenLeft) {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1900) {
          setDivWidthL('340px');
        } else if (windowWidth >= 1600) {
          setDivWidthL('290px');
        } else if (windowWidth >= 1300) {
          setDivWidthL('240px');
        } else if (windowWidth >= 1200) {
          setDivWidthL('200px');
        } else {
          setDivWidthL('340px');
        }
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenLeft]);

  useEffect(() => {
    function handleResize() {
      if (!fullScreenRight) {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1900) {
          setDivWidthR('340px');
        } else if (windowWidth >= 1600) {
          setDivWidthR('290px');
        } else if (windowWidth >= 1300) {
          setDivWidthR('240px');
        } else if (windowWidth >= 1200) {
          setDivWidthR('200px');
        } else {
          setDivWidthR('340px');
        }
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenRight]);

  useEffect(() => {
    function handleResize() {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1280 && windowWidth <= 1359) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('90vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1080px');
            setDivWidthMM('950px');
            setDivPaddingMM('70px');
          } else {
            setDivWidthM('850px');
            setDivWidthMM('750px');
            setDivPaddingMM('70px');
          }
        } else if (windowWidth >= 1360 && windowWidth <= 1439) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1110px');
            setDivWidthMM('1000px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('960px');
            setDivWidthMM('750px');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 1440 && windowWidth <= 1599) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1190px');
            setDivWidthMM('75%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1140px');
            setDivWidthMM('58%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 1600 && windowWidth <= 1699) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1300px');
            setDivWidthMM('75%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1200px');
            setDivWidthMM('56%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 1700 && windowWidth <= 1799) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1300px');
            setDivWidthMM('77%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1200px');
            setDivWidthMM('59%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 1800 && windowWidth <= 1919) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1570px');
            setDivWidthMM('75%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1720px');
            setDivWidthMM('55%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 1920 && windowWidth <= 1999) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1570px');
            setDivWidthMM('76%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1720px');
            setDivWidthMM('58%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 2000 && windowWidth <= 2099) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1570px');
            setDivWidthMM('77%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1720px');
            setDivWidthMM('60%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 2100 && windowWidth <= 2299) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1700px');
            setDivWidthMM('79%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1720px');
            setDivWidthMM('62%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 2300 && windowWidth <= 2399) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1850px');
            setDivWidthMM('2000px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1720px');
            setDivWidthMM('65%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 2400 && windowWidth <= 2699) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('95vw');
            setDivPaddingMM('60px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('2200px');
            setDivWidthMM('2100px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('2600px');
            setDivWidthMM('67%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 2700 && windowWidth <= 3099) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('95vw');
            setDivPaddingMM('60px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('2200px');
            setDivWidthMM('2200px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('2600px');
            setDivWidthMM('70%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 3100 && windowWidth <= 3399) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('95vw');
            setDivPaddingMM('60px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('2600px');
            setDivWidthMM('2600px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('2600px');
            setDivWidthMM('74%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 3400 && windowWidth <= 3599) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('95vw');
            setDivPaddingMM('60px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('2900px');
            setDivWidthMM('2900px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('2600px');
            setDivWidthMM('77%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 3600 && windowWidth <= 3839) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('95vw');
            setDivPaddingMM('60px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('3100px');
            setDivWidthMM('3100px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('2600px');
            setDivWidthMM('2600px');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 3840) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('96vw');
            setDivPaddingMM('60px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('3400px');
            setDivWidthMM('3350px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('3200px');
            setDivWidthMM('3000px');
            setDivPaddingMM('60px');
          }
        }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenLeft, fullScreenRight]);

  const handleGridOrientation = () => {
		setPreviewGridHorizontal(!previewGridHorizontal)
	};


  return(
    <div className="root-dashboard">

      {previewGridActive ? 
      <div className="previewGridBg">
        {listaReplicas.length > 0 ?
      <div className="previewGridWindowOut">
        <div className='previewGridTop'>
          <div className='previewGridOrientationButton' onClick={handleGridOrientation}>Alterar orientação</div>
        </div>
        <div className="previewGridWindowIn" style={{flexFlow: previewGridHorizontal ? 'column wrap' : 'row wrap'}}>
            {listaReplicas.map((item) =>
              <div className="container-preview-r2" key={Math.random()}>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                  <span>{item.width}x{item.height}</span>
                  <Preview {...item} type="replica" className="preview-container" b64={true} />
                </div>
              </div>
            )}
        </div>

      </div>  
          :
          <div className="previewGridWindow2">
            <span className='messageSelectFormat' style={{margin: '0 auto', lineHeight: '25px', fontSize: '16px'}}>Selecione ao menos um formato para visualizar</span>
          </div>  
        }
      </div>
      :
      <div></div>}

    </div>
  )
}

export default DashboardPreview;